/** YYYY-MM-DD ↔ Date utilities. All dates are treated as local. */

export function toIso(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function parseIso(s: string): Date | null {
  const m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (!m) return null;
  const d = new Date(parseInt(m[1]), parseInt(m[2]) - 1, parseInt(m[3]));
  return isNaN(d.getTime()) ? null : d;
}

/** "2026/05/11" or "2026/5/11" → "2026-05-11" */
export function normalizeSlashDate(s: string): string | null {
  const m = s.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})/);
  if (!m) return null;
  const mm = String(parseInt(m[2])).padStart(2, '0');
  const dd = String(parseInt(m[3])).padStart(2, '0');
  return `${m[1]}-${mm}-${dd}`;
}

export function dateRange(startIso: string, endIso: string): string[] {
  const start = parseIso(startIso);
  const end = parseIso(endIso);
  if (!start || !end || start > end) return [];
  const out: string[] = [];
  const cur = new Date(start);
  while (cur <= end) {
    out.push(toIso(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return out;
}

export function addDays(iso: string, days: number): string {
  const d = parseIso(iso);
  if (!d) return iso;
  d.setDate(d.getDate() + days);
  return toIso(d);
}

const WEEKDAY_TC = ['日', '一', '二', '三', '四', '五', '六'];
export function weekdayTc(iso: string): string {
  const d = parseIso(iso);
  return d ? WEEKDAY_TC[d.getDay()] : '';
}

export function isWeekend(iso: string): boolean {
  const d = parseIso(iso);
  if (!d) return false;
  const w = d.getDay();
  return w === 0 || w === 6;
}

export function shortMonthDay(iso: string): string {
  const d = parseIso(iso);
  if (!d) return iso;
  return `${d.getMonth() + 1}/${d.getDate()}`;
}
